import type { SVGProps, FC } from "react"

const SvgPricing: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <path d="M8 0a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8Zm3.5 8.667H8.667V11.5a.667.667 0 0 1-1.333 0V8.667H4.5a.667.667 0 0 1 0-1.333h2.833V4.5a.667.667 0 0 1 1.333 0v2.833H11.5a.667.667 0 0 1 0 1.333Zm0 0" />
  </svg>
)

export default SvgPricing
